import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatMenu } from '@angular/material/menu';

@Component({
    selector: 'app-white-button-menu',
    templateUrl: './white-button-menu.component.html',
    styleUrls: ['./white-button-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WhiteButtonMenuComponent {
    @Input() matMenu: MatMenu;

    @Input()
    label: string = '';

    /**
     * Optional translate params for label (e.g. { total: 3 } for pluralization).
     * When undefined/null, the translate pipe behaves like a normal key lookup.
     */
    @Input()
    labelTranslateParams: any = null;

    @Input()
    icon: string = '';

    @Input()
    svgIcon: string = '';

    @Input()
    disabled: boolean = false;

    @Input()
    isActive: boolean = false;

    @Input()
    showThreeDots: boolean = false;

    /**
     * Optional counter shown before label (e.g. "3 Participants").
     * Kept as "counter" to match app-white-button API.
     */
    @Input()
    counter: number = 0;

    @Input()
    isRounded: boolean = false;

    @Input()
    isLoading: boolean = false;

    @Output()
    onClick = new EventEmitter<any>();

    constructor() {}
}
